import { takeLatest } from 'redux-saga/effects';
import { TYPES } from '../constants';
import loadYardsSaga from './loadYardsSaga';
import createYardSaga from './createYardSaga';
import deleteYardSaga from './deleteYardSaga';
import saveYardSaga from './saveYardSaga';

export default function* yardsSagas(): Generator {
  yield takeLatest(TYPES.LOAD_YARDS.INIT, loadYardsSaga);
  yield takeLatest(TYPES.CREATE_YARD.INIT, createYardSaga);
  yield takeLatest(TYPES.DELETE_YARD.INIT, deleteYardSaga);
  yield takeLatest(TYPES.SAVE_YARD.INIT, saveYardSaga);
}
